export const OFFICE = {
  phoneDisplay: "742 425 0244",
  phoneTel: "tel:+527424250244",
  address: "Gral. Ces\u00e1reo Ramos G. 5, Centro, 40900 T\u00e9cpan de Galeana, Guerrero",
  mapsLink: "https://maps.app.goo.gl/kH2vMpysZUvHG66N8",
  mapsEmbed:
    "https://www.google.com/maps?q=Inmobiliaria%20Rendon%20Ramos%2C%20Gral.%20Ces%C3%A1reo%20Ramos%20G.%205%2C%20Centro%2C%2040900%20T%C3%A9cpan%20de%20Galeana%2C%20Gro.&output=embed",
  hours: "Lunes a S\u00e1bado \u00b7 8:00 am \u2013 4:00 pm",
};

export const LAWYERS = [
  {
    id: "fidel",
    name: "Lic. Fidel Rend\u00f3n Ramos",
    initials: "FR",
    photo: "/assets/lawyers/fidel.jpg",
    credentials: ["Maestr\u00eda en Administraci\u00f3n"],
    phoneDisplay: "+52 742 131 2280",
    whatsapp:
      "https://wa.me/527421312280?text=" +
      encodeURIComponent("Hola Lic. Fidel Rend\u00f3n Ramos, me gustar\u00eda solicitar una asesor\u00eda."),
  },
  {
    id: "ricardo",
    name: "Lic. Ricardo Rend\u00f3n Ramos",
    initials: "RR",
    photo: "/assets/lawyers/ricardo.jpg",
    credentials: ["Maestr\u00eda en Derecho Laboral", "Doctorado en Derecho"],
    phoneDisplay: "+52 744 7115 8503",
    whatsapp:
      "https://wa.me/5274471158503?text=" +
      encodeURIComponent("Hola Lic. Ricardo Rend\u00f3n Ramos, me gustar\u00eda solicitar una asesor\u00eda."),
  },
  {
    id: "laura",
    name: "Lic. Laura Lizeth Urioso Salgado",
    initials: "LU",
    photo: "/assets/lawyers/laura.jpg",
    credentials: ["Abogada"],
    phoneDisplay: "+52 742 114 5314",
    whatsapp:
      "https://wa.me/527421145314?text=" +
      encodeURIComponent("Hola Lic. Laura Urioso Salgado, me gustar\u00eda solicitar una asesor\u00eda."),
  },
];

export const INMOBILIARIA_WHATSAPP = LAWYERS[0];

export const propertyWhatsApp = (title) =>
  "https://wa.me/527421312280?text=" +
  encodeURIComponent(
    `Hola Lic. Fidel Rend\u00f3n Ramos, me interesa la propiedad "${title}" que vi en su p\u00e1gina. \u00bfMe puede dar m\u00e1s informaci\u00f3n?`
  );

export const LEGAL_SERVICES = [
  {
    id: "civil",
    icon: "\u2696\uFE0F",
    title: "Materia Civil",
    items: [
      "Juicios de cumplimiento de contratos",
      "Incumplimiento y rescisi\u00f3n de contratos",
      "Compraventa de bienes inmuebles",
      "Arrendamiento y desocupaci\u00f3n de inmuebles",
      "Otorgamiento y firma de escrituras",
      "Regularizaci\u00f3n de propiedades",
      "Acci\u00f3n reivindicatoria",
      "Juicios de prescripci\u00f3n positiva (usucapi\u00f3n)",
      "Juicios de otorgamiento y firma de escritura",
    ],
  },
  {
    id: "familiar",
    icon: "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67",
    title: "Materia Familiar",
    items: [
      "Divorcio incausado",
      "Pensi\u00f3n alimenticia",
      "Reconocimiento de concubinato",
      "Reconocimiento de paternidad",
      "Sucesiones testamentarias e intestamentarias",
      "Elaboraci\u00f3n y revisi\u00f3n de convenios familiares",
    ],
  },
  {
    id: "laboral",
    icon: "\uD83D\uDC77",
    title: "Materia Laboral",
    items: [
      "Despidos injustificados",
      "Reclamaci\u00f3n de indemnizaciones",
      "Finiquitos y liquidaciones",
      "Pago de salarios y prestaciones",
      "Aguinaldo, vacaciones y prima vacacional",
      "Prima de antig\u00fcedad",
      "Elaboraci\u00f3n y revisi\u00f3n de contratos laborales",
      "Convenios de terminaci\u00f3n laboral",
      "Asesor\u00eda a trabajadores y patrones",
      "Representaci\u00f3n en procedimientos laborales",
    ],
  },
  {
    id: "inmobiliario",
    icon: "\uD83C\uDFE0",
    title: "Servicios Inmobiliarios, Notariales y Registrales",
    groups: [
      {
        title: "Gestor\u00eda y acompa\u00f1amiento jur\u00eddico",
        items: [
          "Integraci\u00f3n y revisi\u00f3n jur\u00eddica de expedientes inmobiliarios",
          "Investigaci\u00f3n de antecedentes de propiedad",
          "Revisi\u00f3n de escrituras y t\u00edtulos de propiedad",
          "Tr\u00e1mites ante Notar\u00edas P\u00fablicas",
          "Elaboraci\u00f3n y revisi\u00f3n de contratos de compraventa",
          "Promesas de compraventa",
          "Cesiones de derechos",
          "Adjudicaciones de bienes inmuebles",
          "Formalizaci\u00f3n y escrituraci\u00f3n de propiedades",
          "Seguimiento de tr\u00e1mites notariales hasta la firma",
        ],
      },
      {
        title: "Catastro Municipal",
        items: [
          "Inscripci\u00f3n de propiedades",
          "Traslados de dominio",
          "Actualizaci\u00f3n de datos catastrales",
          "C\u00e9dulas y certificados catastrales",
          "Rectificaci\u00f3n y actualizaci\u00f3n de superficies y medidas",
          "Constancias y certificados relacionados con el inmueble",
          "Tr\u00e1mites derivados de operaciones de compraventa",
        ],
      },
      {
        title: "Registro P\u00fablico de la Propiedad",
        items: [
          "Inscripci\u00f3n de escrituras",
          "Inscripci\u00f3n de compraventas",
          "Inscripci\u00f3n de adjudicaciones",
          "Inscripci\u00f3n de hipotecas y cancelaciones",
          "Certificados de libertad de gravamen",
          "B\u00fasqueda de antecedentes registrales",
          "Certificados y constancias registrales",
          "Seguimiento de tr\u00e1mites hasta su conclusi\u00f3n",
        ],
      },
    ],
  },
];

export const PROPERTY_TYPES = [
  { value: "casa", label: "Casa" },
  { value: "departamento", label: "Departamento" },
  { value: "terreno", label: "Terreno" },
  { value: "local", label: "Local comercial" },
  { value: "rancho", label: "Rancho / Parcela" },
  { value: "otro", label: "Otro" },
];

export const typeLabel = (value) =>
  (PROPERTY_TYPES.find((t) => t.value === value) || { label: value }).label;
